import MuiTypography, {
  TypographyProps as MuiTypographyProps,
} from '@material-ui/core/Typography';
import styled from 'styled-components';

import { styledSystem, StyledSystemProps } from '../styledSystem';

interface TextProps
  extends Omit<MuiTypographyProps, 'color' | 'display'>,
    StyledSystemProps {
  color?: 'primary' | 'secondary' | 'info' | 'warning' | 'error' | 'success';
  textTransform?:
    | 'none'
    | 'capitalize'
    | 'uppercase'
    | 'lowercase'
    | 'initial'
    | 'inherit';
}

export const Text = styled(
  ({ color, display, textTransform, ...props }: TextProps) => (
    <MuiTypography {...props} />
  )
)`
  &&& {
    color: ${({ theme, color }) =>
      color ? theme.palette.text[color] : theme.palette.text.primary};
    text-transform: ${({ textTransform }) => textTransform ?? 'none'};
    ${styledSystem}
  }
`;
